export const scheduleColumns = {
    columns: [
        {
            header: 'Trunk No',
            field: 'trunkNo',
            className: 'ln-u-text-align-center',
            filter: 'true',
            filterMatchMode: 'contains',
            filterElement: 'onFilterChange'
        },
        {
            header: 'Sequence',
            field: 'sequence',
            className: 'ln-u-text-align-center',
            filter: 'true',
            filterMatchMode: 'contains',
            filterElement: 'onFilterChange'
        },
        {
            header: 'Location No',
            field: 'locationNo',
            className: 'ln-u-text-align-center',
            filter: 'true',
            filterMatchMode: 'contains',
            filterElement: 'onFilterChange'
        },
        {
            header: 'Location Name',
            field: 'locationName',
            className: 'ln-u-text-align-left',
            style: [{ width: '200px' }],
            filter: 'true',
            filterMatchMode: 'contains',
            filterElement: 'onFilterChange'
        },
        {
            header: 'StoreMax',
            field: 'storeTrailerMax',
            className: 'ln-u-text-align-center',
            filter: 'true',
            filterMatchMode: 'contains',
            editor: 'editorForRowEditing',
            filterElement: 'onFilterChange'
        },
        {
            header: 'SVC No',
            field: 'svcNo',
            className: 'ln-u-text-align-center',
            filter: 'true',
            filterMatchMode: 'contains',
            filterElement: 'onFilterChange'
        },
        {
            header: 'SVC Depart Time',
            field: 'svcDepartTime',
            className: 'ln-u-text-align-center',
            filter: 'true',
            filterMatchMode: 'contains',
            filterElement: 'onFilterChange'
        },
        {
            header: 'SVC Pick Time',
            field: 'svcPickTime',
            className: 'ln-u-text-align-center',
            filter: 'true',
            filterMatchMode: 'contains',
            filterElement: 'onFilterChange'
        },
        {
            header: 'Del No',
            field: 'delNo',
            className: 'ln-u-text-align-center',
            filter: 'true',
            filterMatchMode: 'contains',
            filterElement: 'onFilterChange'
        },
        {
            header: 'Daily Pattern',
            field: 'dailyPattern',
            className: 'ln-u-text-align-center',
            filter: 'true',
            filterMatchMode: 'contains',
            filterElement: 'onFilterChange'
        },
        {
            header: 'DU Qty',
            field: 'totalDU',
            className: 'ln-u-text-align-center',
            filter: 'true',
            filterMatchMode: 'contains',
            filterElement: 'onFilterChange'
        },
        {
            header: 'Del No',
            field: 'delNo',
            className: 'ln-u-text-align-center',
            filter: 'true',
            filterMatchMode: 'contains',
            filterElement: 'onFilterChange'
        },
        {
            header: 'Cumulative DU Qty',
            field: 'cumulative',
            className: 'ln-u-text-align-center',
            filter: 'true',
            filterMatchMode: 'contains',
            filterElement: 'onFilterChange'
        },
        {
            header: 'Warehouse Comments',
            field: 'warehouseComments',
            className: 'ln-u-text-align-left',
            filter: 'true',
            filterMatchMode: 'contains',
            filterElement: 'onFilterChange',
            editor: 'editorForRowEditing',
            detail: true
        },
        {
            header: 'Transport Comments',
            field: 'transportComments',
            className: 'ln-u-text-align-left',
            filter: 'true',
            filterMatchMode: 'contains',
            filterElement: 'onFilterChange',
            editor: 'editorForRowEditing',
            detail: true
        },
        {
            header: 'Destination Comments',
            field: 'destinationComments',
            className: 'ln-u-text-align-left',
            filter: 'true',
            filterMatchMode: 'contains',
            filterElement: 'onFilterChange',
            editor: 'editorForRowEditing',
            detail: true
        },
        {
            header: 'Other Comments',
            field: 'otherComments',
            className: 'ln-u-text-align-left',
            filter: 'true',
            filterMatchMode: 'contains',
            filterElement: 'onFilterChange',
            editor: 'editorForRowEditing',
            detail: true
        }
    ]
};
